import React, { useState } from 'react';

export default function StepLocation({ onNext }) {
  const [location, setLocation] = useState('');

  return (
    <div style={{padding:24}}>
      <h3>Location</h3>
      <label>
        Location name
        <input value={location} onChange={(e) => setLocation(e.target.value)} />
      </label>
      <div style={{marginTop:12}}>
        <button onClick={onNext}>Next</button>
      </div>
    </div>
  );
}
